<template>
    <div>
        <content-view v-show="$utils.renderWhen(this,'curriculumOrder')">
            <div class="wrap-container-in">
                <!-- <a-button class="mb16" type="primary">导入订单</a-button> -->
                <a-table bordered :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="changePage" :rowKey="record => record.consumeId">
                    <span slot="price" slot-scope="a, row">{{row.price === 0 ? '免费' : row.price}}</span>
                    <span slot="state" slot-scope="state">{{['','已预约','预约取消','已核销','已预约过期','已禁用','待支付'][state]}}</span>
                    <span slot="consumeTime" slot-scope="consumeTime">{{consumeTime || "-"}}</span>
                    <span slot="action" slot-scope="a, row">
                        <span v-if="getBtnByAuth('courseOrderVerify')">
                            <span v-if="row.state == 3" class="text-disabled">取消核销</span>
                            <a-popconfirm
                            v-else-if="row.state == 1" 
                            title="确认将该课程进行核销?"
                            @confirm="verify(row.consumeId, true)"
                            >
                                <a class="text-primary">核销</a>
                            </a-popconfirm>
                            <span v-else class="text-disabled">核销</span>
                            <a-divider type="vertical"/>
                        </span>

                        <span v-if="getBtnByAuth('courseOrderCancel')">
                            <a-popconfirm
                            v-if="row.state == 1 || row.state == 3 || row.state == 4 || row.state == 5"
                            :title="'确认将该课程进行退款操作吗？'"
                            @confirm="cancelReserve(row.consumeId)"
                            >
                                <a class="text-primary">退款</a>
                            </a-popconfirm>
                            <span v-else class="text-disabled">退款</span>
                            <a-divider type="vertical"/>
                        </span>
                        <!-- <span v-if="getBtnByAuth('courseOrderCancel')">
                            <a-popconfirm
                            v-if="row.state == 1"
                            :title="'确认将该课程取消预约' + (row.price == 0 ? '' : '，并进行退款操作') + '?'"
                            @confirm="cancelReserve(row.consumeId)"
                            >
                                <a class="text-primary">预约取消</a>
                            </a-popconfirm>
                            <span v-else class="text-disabled">预约取消</span>
                            <a-divider type="vertical"/>
                        </span> -->

                        <span v-if="getBtnByAuth('courseOrderState')">
                            <a-popconfirm
                            v-if="row.state == 5"
                            title="确定将该课程取消禁用吗?"
                            @confirm="orderState(row.userTicketId, false)"
                            >
                                <a class="text-primary">取消禁用</a>
                            </a-popconfirm>
                            <a-popconfirm
                            v-else-if="row.state == 1"
                            title="确定将该课程禁用吗?"
                            @confirm="orderState(row.userTicketId, true)"
                            >
                                <a class="text-primary">禁用</a>
                            </a-popconfirm>
                            <span v-else class="text-disabled">禁用</span>
                        </span>
                    </span>
                </a-table>
            </div>
        </content-view>
    </div>
</template>

<script type="text/javascript">
    const columns = [
    {
        title: "课程号",
        dataIndex: "consumeId"
    },
    {
        title: "会员手机号",
        dataIndex: "account"
    },
    {
        title: "课程名称",
        dataIndex: "name"
    },
    {
        title: "开课时间",
        dataIndex: "classTime"
    },
    {
        title: "使用状态",
        dataIndex: "state",
        scopedSlots: { customRender: "state" }
    },
    {
        title: "课程费用",
        dataIndex: "price",
        scopedSlots: { customRender: "price" }
    },
    {
        title: "核销时间",
        dataIndex: "consumeTime",
        scopedSlots: { customRender: "consumeTime" }
    },
    {
        title: "操作",
        key: "action",
        scopedSlots: { customRender: "action" }
    }];
    export default {
        name: "curriculumOrder",
        components: {},
        props: {},
        data() {
            return {
            options: [],
            columns,
            dataSource: [],
            pagination: {
                showTotal: total => `共 ${total} 条数据`,
                showSizeChanger: true,
                showQuickJumper: true,
                total: 0,
                current: 1,
                pageSize: 20
            }
            };
        },
        computed: {},
        methods: {
            changePage(page) {
                this.pagination.pageSize = page.pageSize
                this.pagination.current = page.current
                this.getList()
            },

            // 获取购票订单列表
            getList() {
                this.$api.order
                .courseOrder({
                    body: 
                    {   
                        orderId: this.$route.params.orderId,
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize,
                    }
                })
                .then(res => {
                    this.pagination.total = res.total;
                    this.dataSource = res.data;
                });
            },
            
            // 更改禁用解禁状态
            orderState(userTicketId, flag) {
                // const newState = state == '1' ? '5' : '1'
                this.$api.order.forbidden({
                    params: {id: userTicketId, flag: flag}
                })
                .then(res => {
                    this.$message.success('操作成功',2)
                    this.getList()
                })
            },

            // 取消预约
            cancelReserve(consumeRecordId) {
                this.$api.order.cancelReserve({
                    body: {consumeRecordId: consumeRecordId}
                })
                .then(res => {
                    this.$message.success('操作成功',2)
                    this.getList()
                })
            },

            // 课程核销
            verify(userTicketId, state) {
                this.$api.order.orderVerify({
                    params: {
                        consumeId: userTicketId,
                    }
                })
                .then(res => {
                    this.$message.success('操作成功',2)
                    this.getList()
                })
            },
        },

        created() {},
        mounted() {
            this.getList()
        },
    };
</script>
<style lang="scss">
.wrap-container-in {
  background-color: #fff;
  padding: 24px 32px;
  border-radius: 2px;
}
</style>